//Babel polyfill
import 'babel-polyfill';
//React
import React from 'react';
import ReactDOM from 'react-dom';
// Import F7 Bundle
import Framework7 from 'framework7/framework7.esm.bundle.js';
import Dialog from './components/customF7/dialog/dialog';
// Import F7-React Plugin
import Framework7React from 'framework7-react';

import { prepareManifestUrl } from './lib/utils';
import {
  bootstrapServiceWorker,
  shouldBootstrapServiceWorker
} from './lib/standaloneSwBootstrap';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './css/App.css';

import 'framework7/css/framework7.min.css';
import './css/framework7.bundle.min.css';
import './css/framework7.fix.css';
import './css/f7app.css';
import 'framework7-icons';

import './css/index.css';
import './css/animation.css';
import './css/payment.css';
import './css/forms.css';
import './css/pdf-forms.css';
import './css/desktop.css';
import './css/stepper.css';

//Content
import App from './App';
//Redux
import { applyMiddleware, compose, createStore } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './redux/reducers/rootReducer';
//Middleware
import { logger } from './redux/middleware/logger';
import { crashReporter } from './redux/middleware/crashReporter';
import { hooks } from './redux/middleware/hooks';
import { webSocket } from './redux/middleware/webSocket';
import { cronJobs } from './redux/middleware/cronJobs';
import ErrorBoundary from './components/helpers/ErrorBoundary';
import { startTelemetry } from './telemetry/otel';
import { isOtelConfigured } from './telemetry/config';

const packageJson = require('../package.json');
window.pwaVersion = packageJson.version;

// Init F7-React Plugin
Framework7.use([Framework7React, Dialog]);

// OTel as early as possible (no cookie consent). Session root starts in App
// once window.pwaSession exists.
if (isOtelConfigured()) {
  startTelemetry();
}

let stopRender = false;

prepareManifestUrl();

console.log(`${process.env.REACT_APP_NAME} v.${process.env.REACT_APP_VERSION}`);

if (window.isDesktop) {
  document.body.classList.add('desktop');
} else {
  document.body.classList.add('mobile');
}

const composeEnhancers =
  (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
      traceLimit: 25
    })) ||
  compose;

const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(
      logger,
      crashReporter,
      thunkMiddleware,
      hooks,
      webSocket,
      cronJobs
    )
  )
);

if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function(child) {
    if (child.parentNode !== this) {
      if (console) {
        console.error('Cannot remove a child from a different parent');
        console.log('Child:', child);
        console.log('Child parentNode:', child.parentNode);
        console.log('Current parentNode:', this);
      }
      while (this.childNodes.length > 0) {
        originalRemoveChild.apply(this, [this.childNodes[0]]);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };
}

if (navigator.cookieEnabled) {
  const renderApp = () => {
    !stopRender &&
      ReactDOM.render(
        <ErrorBoundary>
          <Provider store={store}>
            <App />
          </Provider>
        </ErrorBoundary>,
        document.getElementById('app')
      );
  };

  // SW install stays tied to standalone; update checks also run when the page
  // is already controlled by a SW (precache), even if window.standalone is false.
  if (shouldBootstrapServiceWorker()) {
    bootstrapServiceWorker().then(renderApp);
  } else {
    renderApp();
  }
} else {
  const newDiv = document.createElement('div');
  const newContent = document.createTextNode(
    'Um Paperfly nutzen zu können, müssen Sie Ihren Browser so einstellen, dass dieser die Verwendung von Cookies erlaubt!'
  );
  newDiv.appendChild(newContent);
  newDiv.setAttribute(
    'style',
    'background: rgba(0,0,0,.7); padding: 20px; color: #fff; text-align: center; font-weight: bold;'
  );
  document.body.appendChild(newDiv);
}
